import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import {TokenCommonService} from '../token-common.service';
import {AuthService} from '../auth/auth.service';

@Injectable()
export class CertificacionesService extends TokenCommonService {

  constructor(
    http: Http,
    authService: AuthService
  ) {
    super(http, authService);
  }

  get(params?: any) {
    return this.tokenGet(`${ environment.API_URL }certificaciones`, params);
  }

  edit(id, data: FormData) {
    return this.tokenPut(`${ environment.API_URL }certificaciones/${id}`, data);
  }

  create(data: FormData) {
    return this.tokenPost(`${ environment.API_URL }certificaciones`, data);
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/certificaciones/certificaciones.service.ts